/**
 * Header Component
 * 
 * Displays rotation metadata at top of page
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ meta, rotationNumber }) => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Back Button */}
          <button
            onClick={() => navigate('/data-management')}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <span className="mr-2">←</span>
            <span className="font-medium">Back to Rotations</span>
          </button>
          
          {/* Rotation Title */}
          <div className="text-center flex-1">
            <h1 className="text-3xl font-bold text-gray-900">
              Rotation {rotationNumber}
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              {meta?.employee_name}
            </p>
          </div>
          
          {/* Right side spacer (for centering) */}
          <div className="w-32"></div>
        </div>
        
        {/* Secondary Info Row */}
        <div className="flex items-center justify-center gap-6 mt-4 text-sm">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-700">Base:</span>
            <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded font-mono">
              {meta?.base || 'N/A'}
            </span>
          </div>
          
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-700">Equipment:</span>
            <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded font-mono">
              {meta?.equipment || 'N/A'}
            </span>
          </div>
          
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-700">Position:</span>
            <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded font-medium">
              {meta?.position === 'CA' || meta?.position === 'A' ? 'Captain' : 'First Officer'}
            </span>
          </div>
          
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-700">Dates:</span>
            <span className="text-gray-900 font-medium">
              {new Date(meta?.rotation_start_date).toLocaleDateString()} - {new Date(meta?.rotation_end_date).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
